import { API } from "../../../api/constants"
import { authenticatedAxiosInstance } from "../../../auth/AuthenticatedAxios"
import { AddReportDataType, UpdateReportDataType } from "../types"



// GET single report by id
export const getSingleReport = (id: string) => authenticatedAxiosInstance.get(API + `/report/${id}`).then((res) => res.data)

// ADD new report
export const postNewReport = (body: AddReportDataType) => authenticatedAxiosInstance.post(API + "/report", body).then((res) => res.data)

// UPDATE report
export const updateReport = (data: { id: string; body: UpdateReportDataType }) => 
    authenticatedAxiosInstance.put(API + `/report/${data.id}`, data.body).then((res) => res.data)

// DELETE report
export const deleteReport = (id: string) => authenticatedAxiosInstance.delete(API + `/report/${id}`).then((res) => res.data)

// ARCHIVE/UNARCHIVE report
export const toggleReportArchive = (id: string) => authenticatedAxiosInstance.post(API + `/report/${id}/toggle-archive`).then((res) => res.data)

// GET reports by object
export const getReportsByObject = (objectId: string) => 
    authenticatedAxiosInstance.get(API + `/reports/by-object/${objectId}`).then((res) => res.data)

// GET reports by session
export const getReportsBySession = (sessionId: string) => 
    authenticatedAxiosInstance.get(API + `/reports/by-session/${sessionId}`).then((res) => res.data)
